var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-payment-message-box-wrapper" },
    [
      _vm.showPaymentMessageBox
        ? _c("rb-message-box", {
            attrs: { type: "info" },
            scopedSlots: _vm._u(
              [
                {
                  key: "text",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("payment-message-box.info")) +
                          "\n    "
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2968159736
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }